"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// @ts-ignore
const linkhighlighter_1 = __importDefault(require("linkhighlighter"));
window.addEventListener('DOMContentLoaded', () => {
    const linkhighlighterInstance = new linkhighlighter_1.default();
    linkhighlighterInstance.highlight();
    console.info('%cМихаил Драгункин', 'color: #08bb33; font-size: 36px; font-weight: bold; font-family: "Open Sans", "Helvetica Neue", Helvetica, sans-serif');
    // @ts-ignore
    console.info(applicationVersion);
});
